module.exports = __webpack_public_path__ + "img/icon_ep.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon_ep.png
// module id = 319
// module chunks = 0